import React from 'react';
import { FIELD_TYPES } from '../../../libs/formdatavalidator/constants';
import Forms from '../../../libs/utility/formsutility/Forms';
import FormInput from '../forminput/FormInput';
import Switch from '../switch/Switch';
import styles from './IRSLayoutRenderer.styles';
import './directcss/IRSLayoutRenderer.scss';
import { Theme } from '../constants';
import Heading from '../heading/Heading';
import { HEADING } from '../heading/constants/constants';
import FooterWImageAndActionButtons from '../footerwimageandactionbuttons/FooterWImageAndActionButtons';
import RenderInteractionElement from '../../businesslogic/formssection/createform/createformstepper/components/RenderInteractionElement';
import General from '../../../libs/utility/General';
import Button from '../button/Button';
import { BUTTON_TYPE } from '../button/constants';
import TxTooltipWIcon from '../tooltip/txtooltipwicon/TxTooltipWIcon';
import { VEC_ICON_NAME } from '../icons/constants';
import { FORM_FIELD_NAMES, FORM_NAMES } from './constants';

export default function IRSLayoutRenderer({ 
    tempFormFieldsList, 
    toCreateFormData, 
    formsPreLoadedData, 
    isIRSViewOn,
    isStepperViewAvailable = false,
    userInteractionPopupWResponseObj,
    isSingleFormCreationModule=false,
    isReconciliationModule=false,
    setIsIRSViewOnCb = () => {},
    handleIRSFormSubmitCb = () => {},
    onChangeCb = () => {},
    onBlurCb = () => {},
    dropdownOnSelectCb = () => {},
    dispatchNotificationCb = () => {},
    nextButtonProps = {
        text: "Save",
        clickCb: handleIRSFormSubmitCb,
    },
    backButtonProps,
    customBtnsCbMap = {},    
    helpIconProps={},
    showAddPayerBtn = true,
}) {

    const groupedFields = tempFormFieldsList.filter(field => field?.IRSLayout && field.IRSLayout.groupId !== 0);
    const independentFields = tempFormFieldsList.filter(field => field?.IRSLayout?.groupId === 0);

    const checkIsDisabled = (field) => {
        if(field?.isReadonly){
            return true;
        }
        return false;
    }

    const renderGroupedFields = (groupedFields) => {
        const groupIds = [...new Set(groupedFields.map(field => field.IRSLayout.groupId))];

        return groupIds.map(groupId => {
            const groupFields = groupedFields.filter(field => field.IRSLayout.groupId === groupId);
            const minColStart = Math.min(...groupFields.map(field => field.IRSLayout.colStart));
            const minRowStart = Math.min(...groupFields.map(field => field.IRSLayout.rowStart));
            const maxColEnd = Math.max(...groupFields.map(field => field.IRSLayout.colStart + field.IRSLayout.colUnits));
            const maxRowEnd = Math.max(...groupFields.map(field => field.IRSLayout.rowStart + field.IRSLayout.rowUnits));

            const gridStyles = {
                gridColumn: `${minColStart} / span ${maxColEnd - minColStart}`,
                gridRow: `${minRowStart} / span ${maxRowEnd - minRowStart}`,
                border: '1px solid black',
                padding: '5px',
                display: 'grid',
                gridTemplateColumns: `repeat(${maxColEnd - minColStart}, 1fr)`,
            };
            
            return (
                <div key={groupId} style={gridStyles}>
                    {groupFields.map(field => {
                        const { Name, Label, inputValue, IRSLayout, Type } = field;
                        const { colStart, colUnits, rowStart, rowUnits, shouldRenderBorder } = IRSLayout;

                        const fieldStyles = {
                            gridColumn: `${colStart - minColStart + 1} / span ${colUnits}`,
                            gridRow: `${rowStart - minRowStart + 1} / span ${rowUnits}`,
                            border: shouldRenderBorder ? '1px solid black' : 'none',
                            padding: '5px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: "10px",
                        };

                        const inputStyles = {
                            width: '100%',
                        };

                        if(field.isVisible === false){
                            return null
                        }

                        let renderLabel = true;
                        if(IRSLayout?.displayLabel !== undefined && IRSLayout?.displayLabel === false){
                            renderLabel = false;
                        }

                        return (
                            <div key={Name} style={fieldStyles} id={`container_${field.Name}`} className={field.IRSLayout.cssClassname}>
                                {renderLabel && field.Type !== FIELD_TYPES.BOOLEAN && field.Type !== FIELD_TYPES.BUTTON && (
                                    (field.Type === FIELD_TYPES.LABEL && field.FrontEndSource && field.FrontEndSource.trim() !== '' && formsPreLoadedData[field?.FrontEndSource]) ? (
                                        <div dangerouslySetInnerHTML={{ __html: General.sanitizeContent(Forms.replaceKeysInIRSLabelsWVariables(formsPreLoadedData[field?.FrontEndSource], toCreateFormData)) }} />
                                    ) : (
                                        field.Type === FIELD_TYPES.LABEL ? (
                                            <div dangerouslySetInnerHTML={{ __html: General.sanitizeContent(Forms.replaceKeysInIRSLabelsWVariables(Label, toCreateFormData)) }} />
                                        ) : (
                                            // <label style={styles.labelStyle}>{Label}</label>
                                            <label style={styles.labelStyle}>{(field?.BoxInfo?.Box) ? `${field.BoxInfo.Box}. ${field.Label}` : field.Label}
                                            {field?.Validations?.Required?.Value ? <span style={styles.requiredStarLabel}>
                                                <span title={`${field.Name} is Required`}>*</span>
                                            </span> : null}</label>
                                        )
                                    )
                                )}
                                <FormInput
                                    name={field.Name}
                                    type={field.Type}
                                    placeHolder={field.PlaceholderText}
                                    onChangeCb={(e) => onChangeCb(e, field)}
                                    fieldObj={field}
                                    fieldsArr={tempFormFieldsList}
                                    prefixProps={(field.Type === FIELD_TYPES.CURRENCY) ? { text: "$" } : {}}
                                    onBlurCb={(e, inputValidationResult) => onBlurCb(e, inputValidationResult, field)}
                                    hideBorder={(field.Type === FIELD_TYPES.BOOLEAN) ? true : false}
                                    options={(formsPreLoadedData[field?.FrontEndSource] && Array.isArray(formsPreLoadedData[field.FrontEndSource]) ? formsPreLoadedData[field.FrontEndSource] : [])}
                                    dropdownValue={
                                        (field?.inputValue && field.inputValue != "")
                                            ?
                                            (formsPreLoadedData[field?.FrontEndSource] && Array.isArray(formsPreLoadedData[field.FrontEndSource]) ? formsPreLoadedData[field.FrontEndSource] : []).find(item => item.value == field.inputValue)
                                            :
                                            { label: "select", value: "" }
                                    }
                                    dropdownOnSelectCb={(name, selectedOption) => dropdownOnSelectCb(name, selectedOption, field)}
                                    customStyles={(field.Type === FIELD_TYPES.BOOLEAN) ? styles.boxInputFieldLabel : ""}
                                    formsPreLoadedData={formsPreLoadedData}
                                    isIRSViewOn={isIRSViewOn}
                                    disabled={checkIsDisabled(field)}
                                    dispatchNotificationCb={dispatchNotificationCb}
                                    tabIndex={field?.IRSLayout?.TabIndex}
                                    helpIconProps={helpIconProps}
                                />
                                {
                                    (field.Name === FORM_FIELD_NAMES.PAYER_ID  || (field.Name === FORM_FIELD_NAMES.ISSUER_ID && toCreateFormData?.selectedForm?.FormId === FORM_NAMES.FORM1095B))
                                    ? <div style={styles.IRSPayerRecipientButtons}>
                                            {showAddPayerBtn && <Button type={BUTTON_TYPE.PRIMARY} onClickCb={() => customBtnsCbMap["addPayerBtn"](true)} >Add</Button>}
                                            <Button type={BUTTON_TYPE.PRIMARY} onClickCb={() => field?.inputValue ? customBtnsCbMap["editPayerBtn"](field?.inputValue) : customBtnsCbMap["dispatchErrorNotification"]("Please select a Payer")} >Edit</Button>
                                            {field.Name === FORM_FIELD_NAMES.PAYER_ID ? <span style={styles.helpTextIconStyle} ><TxTooltipWIcon
                                            id={field?.Name}
                                            text={"Click here to Add/Edit the Payer"}
                                            iconName={VEC_ICON_NAME.HELP_INFO_ICON}
                                        /></span> : null}
                                        </div>
                                    : null
                                }
                                {
                                    field.Name === FORM_FIELD_NAMES.PAYEE_ID 
                                    ? <div style={styles.IRSPayerRecipientButtons}>
                                            <Button type={BUTTON_TYPE.PRIMARY} onClickCb={() => customBtnsCbMap["addPayeeBtn"](true)} >Add</Button>
                                            <Button type={BUTTON_TYPE.PRIMARY} onClickCb={() => field?.inputValue ? customBtnsCbMap["editPayeeBtn"](field?.inputValue) : customBtnsCbMap["dispatchErrorNotification"]("Please select a Recipient")} >Edit</Button>
                                            <span style={styles.helpTextIconStyle} ><TxTooltipWIcon
                                                id={field?.Name}
                                                text={"Click here to Add/Edit the Recipient"}
                                                iconName={VEC_ICON_NAME.HELP_INFO_ICON}
                                            /></span>
                                        </div>
                                    : null
                                }
                                {   
                                    field.Name === "IntermediaryId" ? 
                                        <div style={styles.addEditIntermediaryButtonsDiv}>
                                            <Button type={BUTTON_TYPE.PRIMARY} onClickCb={() => customBtnsCbMap["handleAddEditIntermediaryAction"]()} >Add Intermediary</Button>
                                            <Button type={BUTTON_TYPE.PRIMARY} onClickCb={() => field?.inputValue ? customBtnsCbMap["handleAddEditIntermediaryAction"](field?.inputValue) : customBtnsCbMap["dispatchErrorNotification"]("Please select an intermediary")} >Edit</Button>
                                        </div>
                                    : null
                                }
                            </div>
                        );
                    })}
                </div>
            );
        });
    };
    
    return (
        <div style={styles.IRSViewMainContainer}>
            {
                isSingleFormCreationModule && <div style={styles.IRSViewHeaderRow}>
                    <div style={styles.selectedFormInfo}>
                        <Heading type={HEADING.H1}>
                            Create Form {toCreateFormData?.selectedForm?.FormLabel}
                        </Heading>
                        <Heading type={HEADING.H3} customStyle={styles.formSubId} >
                            OMB No. {toCreateFormData?.selectedForm?.OMBNo}
                        </Heading>
                    </div>
                    {
                        isStepperViewAvailable && <div style={styles.IRSViewSwitchDiv}> 
                        <span style={styles.irsViewSwitch}>
                            <Switch isOn={isIRSViewOn} name={"IRSViewSwitchOn"} switchUniqueId={"IRSViewSwitchOn"} onColor={Theme.SECONDARY}  handleToggleCb={() => setIsIRSViewOnCb(false)} customSwitchLabelStyle={styles.irsSwitchLabelCustomStyle} customSwitchButtonStyle={styles.irsSwitchButtonCustomStyle} />
                        </span>
                        <span style={styles.irsViewText}>Switch to IRS form view</span>
                    </div>
                    }
                </div>
            }
            <div style={styles.IRSGridContainer}>
                {renderGroupedFields(groupedFields)}

                {independentFields.map(field => {
                    const { Name, Label, inputValue, IRSLayout, Type } = field;
                    const { colStart, colUnits, rowStart, rowUnits, shouldRenderBorder } = IRSLayout;

                    const gridStyles = {
                        gridColumn: `${colStart} / span ${colUnits}`,
                        gridRow: `${rowStart} / span ${rowUnits}`,
                        border: shouldRenderBorder ? '1px solid black' : 'none',
                        padding: '5px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: "10px",
                    };

                    const inputStyles = {
                        width: '100%',
                    };

                    if(field.isVisible === false){
                        return null
                    }

                    let renderLabel = true;
                    if(IRSLayout?.displayLabel !== undefined && IRSLayout?.displayLabel === false){
                        renderLabel = false;
                    }

                    return (
                        <div key={Name} style={gridStyles} id={`container_${field.Name}`} className={field.IRSLayout.cssClassname}>
                            {renderLabel && field.Type !== FIELD_TYPES.BOOLEAN && field.Type !== FIELD_TYPES.BUTTON && (
                                (field.Type === FIELD_TYPES.LABEL && field.FrontEndSource && field.FrontEndSource.trim() !== '' && formsPreLoadedData[field?.FrontEndSource]) ? (
                                    <div dangerouslySetInnerHTML={{ __html: General.sanitizeContent(Forms.replaceKeysInIRSLabelsWVariables(formsPreLoadedData[field?.FrontEndSource], toCreateFormData)) }} />
                                ) : (
                                    field.Type === FIELD_TYPES.LABEL ? (
                                        <div dangerouslySetInnerHTML={{ __html: General.sanitizeContent(Forms.replaceKeysInIRSLabelsWVariables(Label, toCreateFormData)) }} />
                                    ) : (
                                        // <label style={styles.labelStyle}>{Label}</label>
                                        <label style={styles.labelStyle}>{(field?.BoxInfo?.Box) ? `${field.BoxInfo.Box}. ${field.Label}` : field.Label}
                                            {field?.Validations?.Required?.Value ? <span style={styles.requiredStarLabel}>
                                                <span title={`${field.Name} is Required`}>*</span>
                                            </span> : null}
                                        </label>
                                    )
                                )
                            )}
                            <FormInput
                                name={field.Name}
                                type={field.Type}
                                placeHolder={field.PlaceholderText}
                                onChangeCb={(e) => onChangeCb(e, field)}
                                fieldObj={field}
                                fieldsArr={tempFormFieldsList}
                                prefixProps={(field.Type === FIELD_TYPES.CURRENCY) ? { text: "$" } : {}}
                                onBlurCb={(e, inputValidationResult) => onBlurCb(e, inputValidationResult, field)}
                                hideBorder={(field.Type === FIELD_TYPES.BOOLEAN) ? true : false}
                                options={(formsPreLoadedData[field?.FrontEndSource] && Array.isArray(formsPreLoadedData[field.FrontEndSource]) ? formsPreLoadedData[field.FrontEndSource] : [])}
                                dropdownValue={
                                    (field?.inputValue && field.inputValue != "")
                                        ?
                                        (formsPreLoadedData[field?.FrontEndSource] && Array.isArray(formsPreLoadedData[field.FrontEndSource]) ? formsPreLoadedData[field.FrontEndSource] : []).find(item => item.value == field.inputValue)
                                        :
                                        { label: "select", value: "" }
                                }
                                dropdownOnSelectCb={(name, selectedOption) => dropdownOnSelectCb(name, selectedOption, field)}
                                customStyles={(field.Type === FIELD_TYPES.BOOLEAN) ? styles.boxInputFieldLabel : ""}
                                formsPreLoadedData={formsPreLoadedData}
                                isIRSViewOn={isIRSViewOn}
                                disabled={checkIsDisabled(field)}
                                dispatchNotificationCb={dispatchNotificationCb}
                                tabIndex={field?.IRSLayout?.TabIndex}
                                enableEnumModal={
                                    [FORM_FIELD_NAMES.PAYER_ID, FORM_FIELD_NAMES.ISSUER_ID].includes(field.Name) ? showAddPayerBtn : true
                                } //adding this prop temporary for ticket TUM-1794. It should be replaced by BE logic.
                                helpIconProps={helpIconProps}
                            />
                            {
                                (field.Name === FORM_FIELD_NAMES.PAYER_ID  || (field.Name === FORM_FIELD_NAMES.ISSUER_ID && toCreateFormData?.selectedForm?.FormId === FORM_NAMES.FORM1095B))
                                ? <div style={styles.IRSPayerRecipientButtons}>
                                        {showAddPayerBtn && <Button type={BUTTON_TYPE.PRIMARY} onClickCb={() => customBtnsCbMap["addPayerBtn"](true)} >Add</Button>}
                                        <Button type={BUTTON_TYPE.PRIMARY} onClickCb={() => field?.inputValue ? customBtnsCbMap["editPayerBtn"](field?.inputValue) : customBtnsCbMap["dispatchErrorNotification"]("Please select a Payer")} >Edit</Button>
                                        {field.Name === FORM_FIELD_NAMES.PAYER_ID ? <span style={styles.helpTextIconStyle} ><TxTooltipWIcon
                                            id={field?.Name}
                                            text={"Click here to Add/Edit the Payer"}
                                            iconName={VEC_ICON_NAME.HELP_INFO_ICON}
                                        /></span> : null}
                                    </div>
                                : null
                            }
                            {
                                field.Name === FORM_FIELD_NAMES.PAYEE_ID 
                                ? <div style={styles.IRSPayerRecipientButtons}>
                                        <Button type={BUTTON_TYPE.PRIMARY} onClickCb={() => customBtnsCbMap["addPayeeBtn"](true)} >Add</Button>
                                        <Button type={BUTTON_TYPE.PRIMARY} onClickCb={() => field?.inputValue ? customBtnsCbMap["editPayeeBtn"](field?.inputValue) : customBtnsCbMap["dispatchErrorNotification"]("Please select a Recipient")} >Edit</Button>
                                        <span style={styles.helpTextIconStyle} ><TxTooltipWIcon
                                            id={field?.Name}
                                            text={"Click here to Add/Edit the Recipient"}
                                            iconName={VEC_ICON_NAME.HELP_INFO_ICON}
                                        /></span>
                                    </div>
                                : null
                            }
                            {   
                                field.Name === "IntermediaryId" ? 
                                    <div style={styles.addEditIntermediaryButtonsDiv}>
                                        <Button type={BUTTON_TYPE.PRIMARY} onClickCb={() => customBtnsCbMap["handleAddEditIntermediaryAction"]()} >Add Intermediary</Button>
                                        <Button type={BUTTON_TYPE.PRIMARY} onClickCb={() => field?.inputValue ? customBtnsCbMap["handleAddEditIntermediaryAction"](field?.inputValue) : customBtnsCbMap["dispatchErrorNotification"]("Please select an intermediary")} >Edit</Button>
                                    </div>
                                : null
                            }
                        </div>
                    );
                })}
            </div>
            {
                isSingleFormCreationModule && <div style={styles.IRSViewFooterRow}>
                    <FooterWImageAndActionButtons
                        nextButton={nextButtonProps}
                        backButton={backButtonProps}
                    >
                    </FooterWImageAndActionButtons>
                </div>
            }
            {
                (userInteractionPopupWResponseObj?.type) ? <RenderInteractionElement interactionObj={userInteractionPopupWResponseObj}  userInteractionPopupWResponseObj={userInteractionPopupWResponseObj}/> : null
            }
            
        </div>
    );
}